<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM订单产品分布数据 right_1"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')} 合计：${total_num}`"
      :tooltipText="'开单提交实时金额数据，不含本厂责任售后'"
    ></chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="right_1" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import { distributionData } from "@/api/cockpit/jyl";
import {
  formatTime,
  getNextMonth,
  getLastDate,
  getFirstDate,
  arrDataFormat,
} from "@/utils/index";
export default {
  mixins: [resize],
  name: "right_1",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      date: new Date(),
      chartData: "",
      total_num: 0,
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    //获取数据
    getData() {
      distributionData({
        add_time: getFirstDate(this.date, "yyyy-MM-dd"),
      }).then((resp) => {
        this.chartData = arrDataFormat(resp.data.list);
        this.total_num = resp.data.total_money;
        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("right_1"));
      this.setOptions();
    },
    setOptions() { 
      const color = [
        "#1158a7",
        "#0983ff",
        "#59abf6",
        "#abd6fc",
        "#29beb9",
        "#3bffd0",
        "#22e4ff",
        "#40E0D0",
      ];
      // const valArr = this.chartData.map((m) => m.value);
      // const maxVal = Math.max(...valArr);
      this.chart.setOption({
        polar: {
          radius: [30, "80%"],
        },
        radiusAxis: {
          // max: maxVal + 1000,
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
            },
          },
        },
        angleAxis: {
          type: "category",
          data: this.chartData.map((m) => m.name),
          startAngle: 75,
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#C0C4CC",
          },
        },

        tooltip: {},
        series: {
          type: "bar",
          data: this.chartData.map((m, index) => {
            return {
              value: m.value,
              itemStyle: {
                color: color[index],
              },
              label: {
                color: "#C0C4CC",
              },
            };
          }),
          coordinateSystem: "polar",
          label: {
            show: true,
            position: "inside",
            formatter: "{c}元",
          },
        },
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-dd"), +1);
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 35vh;
  #right_1 {
    height: 100%;
  }
}
</style>
